import { Empty } from 'antd';

const EmptyForm = () => (
    <Empty
        image={Empty.PRESENTED_IMAGE_DEFAULT}
        imageStyle={{
            height: 60,
        }}
        description="No data!"
        style={{ width: "100%", padding: 50 }}
    >
    </Empty>
);

export default EmptyForm;